<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview v-bind:title="'Forum Alumni'">
                   <template v-slot:toolbar>
                        <ButtonComponent v-if="grup_user === 18"  colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal2('Tambah')"
                        dataTitleTooltip="Tambah Data" />
                   </template>
                    <template v-slot:body>
                        <v-card>
                        <v-row class="mb-4" v-if="grup_user === 1">
                            <div class="row mt-2">
                                <div class="col-md-3 mx-5">
                                    <div class="row" style="border-color:#FFB800;border-style: solid;">
                                        <div class="col-md-3 text-center" style="background-color: #FFB800;">
                                            <i class="fa fa-clock"
                                                style="color: white;font-size: 30px;margin-top: 25%;"></i>
                                        </div>
                                        <div class="col-md-9 text-left" style="margin-top: auto;">
                                            <div class="isi" style="margin-top: 2%;">
                                                <b>
                                                    <h5 class="card-title" style="font-size: 1.75rem">{{
                                                        menunggu_persetujuan }}</h5>
                                                </b>
                                                <p class="font-weight-bold" style="font-size: 1.25rem;">Menunggu Persetujuan</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-1"></div>
                                <div class="col-md-3 mx-5">
                                    <div class="row" style="border-color:#3751E4;border-style: solid;">
                                        <div class="col-md-3 text-center" style="background-color: #3751E4;">
                                            <i class="fa fa-check"
                                                style="color: white;font-size: 30px;margin-top: 25%;"></i>
                                        </div>
                                        <div class="col-md-9 text-left" style="margin-top: auto;">
                                            <div class="isi" style="margin-top: 2%;">
                                                <b>
                                                    <h5 class="card-title" style="font-size: 1.75rem">{{ disetujui }}</h5>
                                                </b>
                                                <p class="font-weight-bold" style="font-size: 1.25rem;">Disetujui</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-1"></div>
                                <div class="col-md-3 mx-5">
                                    <div class="row" style="border-color:#EF4848;border-style: solid;">
                                        <div class="col-md-3 text-center" style="background-color: #EF4848;">
                                            <i class="fa fa-times"
                                                style="color: white;font-size: 30px;margin-top: 25%;"></i>
                                        </div>
                                        <div class="col-md-9 text-left" style="margin-top: auto;">
                                            <div class="isi" style="margin-top: 2%;">
                                                <b>
                                                    <h5 class="card-title" style="font-size: 1.75rem">{{ ditolak }}</h5>
                                                </b>
                                                <p class="font-weight-bold" style="font-size: 1.25rem;">Ditolak</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-row>

                        <div class="row mt-20" v-if="grup_user === 1" >
                            <div class="col-lg-12">
                                <div class="tabs">
                                    <div :key="1" @click="selectTab(1)" :class="{ 'active': activeTab === 1 }">
                                        Menunggu Persetujuan
                                    </div>
                                    <div :key="2" @click="selectTab(2)" :class="{ 'active': activeTab === 2 }">
                                        Disetujui
                                    </div>
                                    <div :key="3" @click="selectTab(3)" :class="{ 'active': activeTab === 3 }">
                                        Ditolak
                                    </div>
                                </div>
                                <div class="tab-content">
                                    <div v-show="activeTab === 1">
                                        <div class="row" v-if="jumlah_terpilih > 0" id="data_terpilih" 
                                            style="border-color: transparent;">
                                            <div class="col-md-6" style="border-color: transparent;">
                                                <p  v-if="showJumlah" id="jumlah"> {{ jumlah_terpilih }} terpilih</p>
                                            </div>
                                            <div class="col-md-6" id="tombol_konfirmasi" v-if="showTombolKonfirmasi"
                                                style="border-color: transparent;display: flex; justify-content: flex-end;margin-left: auto;margin-right: 0;">
                                                <v-btn class="tombol_setujui ml-5 mr-5" @click="formSetuju()"
                                                    style="color: white;background-color: #3751E4;">Setujui</v-btn>
                                                <v-btn class="tombol_tolak" @click="formTolak()"
                                                    style="color: white; background-color: #EF4848;">Tolak</v-btn>
                                            </div>
                                        </div>
                                        <v-data-table :headers="headers_menunggu" :items="data.menunggu">
                                            <template v-slot:item.select="{ item }">
                                                <v-checkbox v-if="grup_user === 1" v-model="selectedItems" :value="item.forum_key"
                                                    @change="updateSelectedItems" hide-details color="primary"
                                                    class="custom-checkbox" style="border-color: transparent;">
                                                </v-checkbox>
                                            </template>
                                            <template v-slot:item.status="{ item }">
                                                <b-badge class="mr-1" variant="warning"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                                <ButtonComponent colors="#3751E4" name="view" v-b-modal.modal_get
                                                    @click.native="openModal('Detail',item)" dataTitleTooltip="View" />
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                                <div class="tab-content">
                                    <div v-show="activeTab === 2">
                                        <v-data-table :headers="headers" :items="data.disetujui">
                                            <template v-slot:item.status="{ item }">
                                                <b-badge class="mr-1" variant="success"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                                <ButtonComponent colors="#3751E4" name="view" v-b-modal.modal_get
                                                    @click.native="openModal('Detail',item)" dataTitleTooltip="View" />
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                                <div class="tab-content">
                                    <div v-show="activeTab === 3">
                                        <v-data-table :headers="headers_ditolak" :items="data.ditolak">
                                            <template v-slot:item.status="{ item }">
                                                <b-badge class="mr-1" variant="danger"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                                <ButtonComponent colors="#3751E4" name="view" v-b-modal.modal_get
                                                    @click.native="openModal('Detail',item)" dataTitleTooltip="View" />
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-20" v-if="grup_user === 18">
                            <div class="col-lg-12">
                                    <v-data-table :headers="headers_alumni" :items="data_alumni" >
                                        <template v-slot:item.status="{item}">
                                           <div v-if="item.status === 'Menunggu' " >
                                                <b-badge class="mr-1" variant="warning"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                           </div>
                                           <div v-else-if="item.status === 'Disetujui' " >
                                                <b-badge class="mr-1" variant="success"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                           </div>
                                           <div v-else-if="item.status === 'Ditolak' " >
                                                <b-badge class="mr-1" variant="danger"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                           </div>
                                        </template>
                                        <template v-slot:item.lampiran="{item}">
                                           
                                                <span @click="downloadItem(item.lampiran)" class="cursor-hand">{{ item.lampiran }}</span>
                                           
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <div v-if="item.status === 'Menunggu'" >
                                                <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal dataTitleTooltip="Edit" @click.native="openModal2('Edit',item)"></ButtonComponent>
                                                <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.forum_key)" dataTitleTooltip="Hapus" /> 
                                            </div>
                                        </template>
                                    </v-data-table>
                            </div>
                        </div>
                        <div class="row mt-20" v-if="grup_user === 28">
                            <div class="col-lg-12">
                                    <v-data-table :headers="headers_alumni2" :items="data_alumni2" >
                                        <template v-slot:item.status="{item}">
                                           <div v-if="item.status === 'Menunggu' " >
                                                <b-badge class="mr-1" variant="warning"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                           </div>
                                           <div v-else-if="item.status === 'Disetujui' " >
                                                <b-badge class="mr-1" variant="success"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                           </div>
                                           <div v-else-if="item.status === 'Ditolak' " >
                                                <b-badge class="mr-1" variant="danger"
                                                    style="padding-left: 3%; padding-right: 3%; padding-top: 2%; padding-bottom: 2%; color: white;">{{
                                                        item?.status }}</b-badge>
                                           </div>
                                        </template>
                                        <template v-slot:item.lampiran="{item}">
                                           
                                                <span @click="downloadItem(item.lampiran)" class="cursor-hand">{{ item.lampiran }}</span>
                                           
                                        </template>
                                      
                                    </v-data-table>
                            </div>
                        </div>

                        </v-card>
                    </template>
                </KTCodePreview>

                <b-modal @ok="onSubmit" ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" 
                    id="modal" :title="`${statusModal} Forum Alumni`" >
                    <b-form>
                        <b-form-group label="Nama Judul">
                            <b-form-input type="text" required v-model="request.judul"
                                placeholder="Masukkan Judul">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Isi Forum">
                            <b-form-textarea required v-model="request.isi" 
                                placeholder="Masukan isi forum">
                            </b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Lampiran" >
                            <b-form-file
                                v-model="lampiran"
                                :state="Boolean(lampiran)"
                                placeholder="Choose a file"
                                drop-placeholder="Drop file here..."
                                @change="onFileUpload"
                                ref="file"
                            >
                            </b-form-file>
                        </b-form-group>
                     </b-form>
                </b-modal>  
                
                <b-modal no-enforce-focus id="modal_get" size="lg" :title="`Detail Form`" hide-footer>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">Oleh:</div>
                                <div class="col-md-9">{{ dataModal.name }}</div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">Judul:</div>
                                <div class="col-md-9">{{ dataModal.judul }}</div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">Isi:</div>
                                <div class="col-md-9">{{ dataModal.isi }}</div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">Lampiran:</div>
                                <div class="col-md-9"><a :href="`${$endpoint}uploads/forum_alumni/${dataModal.lampiran}`">{{ dataModal.lampiran }}</a></div>
                            </div>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<style scoped>
.tabs {
    display: flex;
}

.tabs div {
    padding: 10px;
    cursor: pointer;
    border: 1px solid #ccc;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    margin-right: 5px;
}

.tabs div.active {
    background-color: #007bff;
    color: #fff;
}

.tab-content div {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 0 0 5px 5px;
}

/* .tab-content div:not(:first-child) {
    display: none;
} */

.custom-checkbox .v-input--selection-controls .v-input__control {
    border-color: transparent;
}

.custom-checkbox .v-input--selection-controls .v-input__slot {
    color: inherit;
    /* Optional: set the text color to match your theme */
}
</style>

<style scoped>
  .cursor-hand{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
</style>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from '@/view/content/components/button/buttonComponent.vue';
import axios from "axios";


export default {
    data() {
        return {
            activeTab: 1,
            menunggu_persetujuan: null,
            disetujui: null,
            ditolak: null,
            jumlah_terpilih: 0,
            headers: [
                { text: "No",           value: "no" },
                { text: "NIM",          value: "nim" },
                { text: "Nama",         value: "name" },
                { text: "Judul Forum",  value: "judul" },
                { text: "Status",       align: "center", value: "status" },
                { text: "Aksi",         value: "action" }
            ],

            headers_alumni : [
                {text : 'No'            , value : "no"},
                {text : "NIM"           , value : "nim"},
                {text : 'Nama'          , value : 'nama'},
                {text : 'Judul Forum'   , value : 'judul'},
                {text : 'Lampiran'      , value : 'lampiran'},
                {text : 'Status'        , value :'status'},
                {text : 'Aksi'          , value : 'action'}
            ],

            headers_alumni2 : [
                {text : 'No'            , value : "no"},
                {text : "NIM"           , value : "nim"},
                {text : 'Nama'          , value : 'nama'},
                {text : 'Judul Forum'   , value : 'judul'},
                {text : 'Lampiran'      , value : 'lampiran'},
                {text : 'Status'        , value :'status'}
            ],

            headers_menunggu: [
                { text: '',         value: 'select', align: 'center', sortable: false, width: '4%', },
                { text: "No",       value: "no" },
                { text: "NIM",      value: "nim" },
                { text: "Nama",     value: "name" },
                { text: "Judul",    value: "judul" },
                { text: "Status",   align: "center", value: "status" },
                { text: "Aksi",     value: "action" }
            ],
            headers_ditolak: [
                { text: '',         value: 'select', align: 'center', sortable: false, width: '4%', },
                { text: "No",       value: "no" },
                { text: "NIM",      value: "nim" },
                { text: "Nama",     value: "name" },
                { text: "Judul",    value: "judul" },
                { text: "Status",   align: "center", value: "status" },
                { text: "Aksi",     value: "action" }
            ],
            data: {
                menunggu    : [],
                disetujui   : [],
                ditolak     : [],
            },

            request : {
                forum_key       : null,
                judul           : null,
                isi             : null,
               
            },

            lampiran : null,
            data_alumni : [],
            data_alumni2 : [],
            status : null,
            id_forum : null,
            selectedItems: [],
            index : 0,
            dataModal: {
                forum_key   : null,
                name        : null,
                korps       : null,
                tahun       : null,
                judul       : null,
                isi         : null,
                lampiran    : null,
                tgl         : null

            },
            showTombolKonfirmasi : true,
            showJumlah : true,
            grup_user : null,
            statusModal : null,
        };
    },
    components: {
        KTCodePreview,
        ButtonComponent,
    },
    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Forum Alumni" },
        ]),
        this.getForumDisetujui(),
        this.getForumDitolak(),
        this.getForumMenunggu(),
        this.getForumAlumni(),
        this.getForumAlumniGeneral()

    },
    methods: {
        selectTab(index) {
            this.activeTab = index;
        },

        async openModal(status,itemData = null) {

            this.statusModal = status;

            this.dataModal = {
                forum_key   : null,
                id_user     : null,
                name        : null,
                korps       : null,
                tahun       : null,
                judul       : null,
                isi         : null,
                lampiran    : null,
                tgl         : null
            }

            const result = await axios.get(`forum-alumni/admin/detail/${itemData.forum_key}`);
            const result_data = result.data.data;
            
            this.dataModal.forum_key    = result_data.forum_key;
            this.dataModal.id_user      = result_data.id_user;
            this.dataModal.name         = result_data.name;
            this.dataModal.korps        = result_data.korps;
            this.dataModal.tahun        = result_data.tahun;
            this.dataModal.judul        = result_data.judul;
            this.dataModal.isi          = result_data.isi;
            this.dataModal.lampiran     = result_data.lampiran;
            this.dataModal.tgl          = result_data.tgl;
        },


        openModal2(status,itemData = null){
            this.statusModal = status

            this.request = {
               forum_key        : null,
               judul            : null,
               isi              : null,
               lampiran         : null 
            }

            if(status == 'Edit'){
                this.request.forum_key          = itemData.forum_key
                this.request.judul              = itemData.judul
                this.request.isi                = itemData.isi
                this.request.lampiran           = itemData.lampiran
            }
        },

        updateSelectedItems() {
            // Handle selected items as needed
            this.jumlah_terpilih = this.selectedItems.length;
        },
        async formSetuju() {
            if (this.selectedItems.length < 0) {
                this.$swal(`Failed`);
            }

            const res = await axios.post('forum-alumni/admin/approve',{
                    id_forum    : this.selectedItems
            })

            this.refreshData(res,'Approve Success')
            this.data.menunggu = [];
            this.selectedItems = [];

            this.getForumMenunggu();
            this.jumlah_terpilih = 0;
            
        
        },

        
    

        async formTolak() {
            if (this.selectedItems.length < 0) {
                this.$swal(`Failed`);
            }

            const res = await axios.post('forum-alumni/admin/decline',{
                    id_forum    : this.selectedItems
            })

            this.refreshData(res,'Decline Success')
            this.data.menunggu = [];
            this.selectedItems = [];

            this.getForumMenunggu();
            this.jumlah_terpilih = 0;

        },
        refreshData(result,alert) {
            if(result.data.meta.code == 200){
                this.$swal({
                    title: `${alert}`,
            
                    buttons: {
                        confirm: {
                            text: 'OK',
                            value: true,
                            visible: true,
                            className: 'swal-ok-btn',
                        },
                    },
                })

                this.data.disetujui = [];
                this.data.ditolak   = [];
                this.getForumDisetujui();
                this.getForumDitolak();

            }else if(result.data.meta.code == 500){
                this.$swal({
                    title: `${alert}`,
                    
                    buttons: {
                        confirm: {
                            text: 'Failed',
                            value: true,
                            visible: true,
                            className: 'swal-failed-btn',
                        },
                    },
                })
            }
               
        },

        refreshDataAlumni(result,alert){
            if(result.data.meta.code == 200){
                this.$swal({
                    title: `Success ${alert} data`,
            
                    buttons: {
                        confirm: {
                            text: 'OK',
                            value: true,
                            visible: true,
                            className: 'swal-ok-btn',
                        },
                    },
                })

              this.getForumAlumni();

            }else if(result.data.meta.code == 500){
                this.$swal({
                    title: `${alert}`,
                    
                    buttons: {
                        confirm: {
                            text: 'Failed',
                            value: true,
                            visible: true,
                            className: 'swal-failed-btn',
                        },
                    },
                })
            }
        },

        async getForumAlumni(){
            try{

                if(this.grup_user == 18){

                    if(this.data_alumni.length > 0){
                        this.data_alumni = [];
                    }

                    await axios.get('forum-alumni/alumni/index').then(response => {
                        if(response.status == 200){
                            response.data.data.some((e,index) => {

                                var object = {
                                    no              : index + 1,
                                    forum_key       : e.forum_key,
                                    nim             : e.nim,
                                    nama            : e.nama,
                                    judul           : e.judul,
                                    isi             : e.isi,
                                    lampiran        : e.lampiran,
                                    status          : e.status,
                                }

                               this.data_alumni.push(object);

                                return index > e.length;
                            })
                        }
                    })

                 
                }

            }catch(error){  
                this.$swal('Failed');
            }
        },

        async getForumAlumniGeneral(){
            if(this.grup_user == 28){
                if(this.data_alumni2.length > 0){
                    this.data_alumni2 = [];
                }

                await axios.get('forum-alumni/alumni/general').then(response => {
                    if(response.status == 200){
                        response.data.data.some( (e,index) => {
                            var object = {
                                    no              : index + 1,
                                    nim             : e.nim,
                                    nama            : e.nama,
                                    judul           : e.judul,
                                    isi             : e.isi,
                                    lampiran        : e.lampiran,
                                    status          : e.status,
                                }

                               this.data_alumni2.push(object);
                                return index > e.length;
                        } )
                    }
                })
            }
        },

        async onSubmit(){
            const form = this.request
            if(form.forum_key === null){
                this.createForumAlumni(form);
            }else{
                this.updateForumAlumni(form);
            }
        },

        onFileUpload(event) {
            const file = event.target.files[0];
            if(file){
                this.fileName = file.name;
                this.lampiran = file;
                
                
            }
        },

        async createForumAlumni(form){
            try{
                const formData = new FormData();

                formData.append('lampiran',this.lampiran);
                formData.append('judul',form.judul);
                formData.append('isi',form.isi);

                const result = await axios.post('forum-alumni/alumni/save',formData,{
                    headers : {
                        'Content-type' : 'multipart/form-data'
                    }
                }
                    
                );
                this.refreshDataAlumni(result,'Store');


            }catch(error){
                this.$swal('Failed');
            }
        },  

        async updateForumAlumni(form){
            try{

                const formData = new FormData();
                formData.append('lampiran',this.lampiran);
                formData.append('judul',form.judul);
                formData.append('isi',form.isi);

                const result = await axios.post(`forum-alumni/alumni/update/${form.forum_key}`,formData,
                    {
                        headers : {
                            'Content-Type' : 'multipart/form-data'
                        }
                    }
                );
                this.refreshDataAlumni(result,'Update');

            }catch(error){
                this.$swal('Failed');
            }
        },  
        

        async getForumDisetujui(){
            try{

                if(this.data.disetujui.length == 0){
                    this.data.disetujui = [];
                }

                this.grup_user = JSON.parse(
                    localStorage.getItem('dataLogin')
                ).grup_user;


                if(this.grup_user == 1){
                    await axios.get('forum-alumni/admin/index/1').then(response => {
                        if(response.status == 200){
                            response.data.data.some((e,index) => {
                                var object = {
                                    no              : index + 1,
                                    forum_key       : e.forum_key,
                                    nim             : e.nim,
                                    name            : e.name,
                                    judul           : e.judul,
                                    status          : e.status,
                                }

                                this.data.disetujui.push(object);
                                return index > e.length;
                            })
        
                        }
                    })                

                    if(this.data.disetujui == []){
                        this.disetujui = 0;
                    }else{
                        this.disetujui = this.data.disetujui.length;
                    }

                }
    
            }catch(error){
                this.$swal(`Failed`);
            }
        },

        downloadItem(label) {
            const externalRouteUrl = this.$endpoint + 'uploads/forum_alumni/' + label;
            window.open(externalRouteUrl, '_blank');
        },

        async getForumMenunggu(){
            try{

                if(this.data.menunggu.length == 0){
                    this.data.menunggu = [];
                }

                this.grup_user = JSON.parse(
                    localStorage.getItem('dataLogin')
                ).grup_user;

                if(this.grup_user == 1){
                    await axios.get('forum-alumni/admin/index/0').then(response => {
                        if(response.status == 200){
                            response.data.data.some((e,index) => {
                                
                                var object = {
                                    no      : index + 1,
                                    forum_key     : e.forum_key,
                                    nim     : e.nim,
                                    name    : e.name,
                                    judul   : e.judul,
                                    status  : e.status,
                                }

                                this.data.menunggu.push(object);
                                return index > e.length;
                            })
                        }
                    })

                    if(this.data.menunggu == []){
                        this.menunggu_persetujuan = 0;
                    }else{
                        this.menunggu_persetujuan = this.data.menunggu.length;
                    }

                }

            }catch(error){
                this.$swal(`Failed`);
            }
        },

        async getForumDitolak(){
            try{

                if(this.data.ditolak.length == 0){
                    this.data.ditolak = [];
                }

                this.grup_user = JSON.parse(
                    localStorage.getItem('dataLogin')
                ).grup_user;

                if(this.grup_user == 1){
                    await axios.get('forum-alumni/admin/index/2').then(response => {
                        if(response.status == 200){
                            response.data.data.some((e,index) => {
                                
                                var object = {
                                    no      : index + 1,
                                    forum_key     : e.forum_key,
                                    nim     : e.nim,
                                    name    : e.name,
                                    judul   : e.judul,
                                    status  : e.status,
                                }

                                this.data.ditolak.push(object);
                                return index > e.length;
                            })
                        }
                    })

                    if(this.data.ditolak == []){
                        this.ditolak = 0;
                    }else{
                        this.ditolak = this.data.ditolak.length;
                    }
                }

            }catch(error){
                this.$swal('Failed');
            }
        },

        async deleteData(key){
            try {
            this.$swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover this item!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
            }).then(async (result) => {
            if (result.value) {
                // User confirmed, so delete the item
                const result = await axios.delete(`forum-alumni/alumni/delete/${key}/`)
                
                this.refreshDataAlumni(result, 'Delete')
            } else {
                // User canceled, so do nothing
            }
            })
        } catch (err) {
            this.$swal(`Failed`);
        }
        }
        

        // refreshData(result, alert) {
        //     if (result.data.meta.code == 200) {
        //         this.$swal(`Success ${alert} Data`);
        //         this.getData()
        //     } else if (result.data.meta.code == 409) {
        //         this.$swal(`Failed, Data Already Exist!`);
        //         this.getData()
        //     } else {
        //         this.$swal(`Failed ${alert} Data`);
        //     }
        // },
    }
}
</script>